import data from './assets/CodigosDeProcedencia.json';


export const getEntorno = () => {
  const url_actual = globalThis.location.hostname
  const data_cases = [
    {
      case: "www.prosegur.es",
      value: "PA",
    },
    {
      case: "movistarproseguralarmas.es",
      value: "MPA",
    },
  ];

   const matchingCase = data_cases.find((data) => (url_actual===data.case) ? data : null);

    return matchingCase ? matchingCase.value : null;

};


export const extractParamUrl=(parametro)=>{
    try {
      const url=globalThis.location.href
  
      let parsedUrl = new URL(url);
  
  
      let parametros = new URLSearchParams(parsedUrl.search);
  
      
      return parametros.get(parametro);
    } catch (error) {
      console.error("Error el parametro no existe en la url actual:", error);
      return null;
    }
  }


const searchDataJson = (utm_source) =>{
  var valor = false;
  return new Promise((resolve, reject) => {
    data.forEach(element => {
      if(element.utm_source === utm_source){
        valor = true;
        resolve(element.Cod_Procedencia)
      }
    });
    if(!valor){
       resolve(null)
    }
  })
}


export const getCodProvincia = async  (param) => {
  const origen = extractParamUrl(param);
  const origenFound = await searchDataJson(origen);

  return origenFound ? origenFound : getCodProvinciaCallmeWithouthParams();
};


  
const getCodProvinciaCallmeWithouthParams=()=>{
    const url_actual=globalThis.location.hostname

    // Comprueba si la URL contiene parámetros
    if (globalThis.location.href.includes('?') || globalThis.location.href.includes('&')) {
      return null;
        
    }
  
    const data_cases = [
        {
            case: "www.prosegur.es",
            value: "20031"
        },
        {
            case: "movistarproseguralarmas.es",
            value: "20071"
        }
    ];
  
    const matchingCase = data_cases.find(data => (url_actual===(data.case)) ? data : null);
    return matchingCase ? matchingCase.value : null;
  }
  
  